import { ElementProps as _ElementProps } from "./AbsoluteElement";
export { default as AbsoluteElement } from "./AbsoluteElement";
export { default as StaticElement } from "./StaticElement";

export type ElementProps = _ElementProps;
